<div>
    <section class="check-section">
        <mat-checkbox [(ngModel)]="data[isSelectedVar]" name="isSelected" [disabled]="isCheckboxDisabled"
            (change)="onSelectChange()">
        </mat-checkbox>
    </section>
</div>